var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process-container",class:{ mine: _vm.mine }},[_c('div',{staticClass:"left"},[_vm._v(_vm._s(_vm.percent)+"%")]),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.number))]),_c('div',{staticClass:"block",style:({ background: `${ _vm.mine ? '#F6CBCB' : '#DDDDDD'}`, width: `${_vm.percent}%`})})])
}
var staticRenderFns = []

export { render, staticRenderFns }